export const TAB_KEYS = {
  bidding: 'bidding',
  collaborators: 'collaborators',
  documents: 'documentForm',
  notes: 'notesForm',
  productDetails: 'productForm',
  quoteDetails: 'quoteDetailsForm',
  rate: 'rate',
  shippingTerms: 'shippingTermsSearchForm',
  stops: 'stopsForm',
};

export const QUOTE_STATUSES = {
  awarded: 'Awarded',
  cancelled: 'Cancelled',
  internalReview: 'Internal Review',
  // todo: add new types: spot bid, rating result
  new: 'New',
  openForBid: 'Open for Bid',
  readyForAward: 'Ready for Award',
  unAwarded: 'Unawarded',
} as const;

export const formsName = [
  'quoteDetailsForm',
  'stopsForm',
  'productForm',
  'shippingTermsSearchForm',
  'notesForm',
  'documentForm',
  'cargoTypeForm',
];

export const formsButtons = {
  rate: 'rateQuote',
  save: 'saveQuoteForm',
  sendForReview: 'sendForReviewForm',
  spotBid: 'spotBidForm',
  unaward: 'unawardForm',
};

export const USER_ROLES = {
  admin: 'Halliburton Admin',
  approver: 'Halliburton Approver',
  creator: 'Halliburton Creator',
  hbChina: 'Role for HB China users',
};

export const defaultTime = { hour: 12, minute: 0, second: 0 };

export const quoteElements = {
  addFile: 'addFile',
  bidDuration: 'bidDuration',
  bidding: 'bidding',
  collaborators: 'collaborators',
  currency: 'currency',
  deliveryDate: 'deliveryDate',
  notes: 'notes',
  productDetails: 'productDetails',
  removeFile: 'removeFile',
  shippingDates: 'shippingDates',
  shippingTerms: 'shippingTerms',
  transportationAddress: 'transportationAddress',
  transportationDetails: 'transportationDetails',
};
